export default __webpack_public_path__ + "static/media/worker list.855b5423.svg";